import { useMemo } from 'react'
// Deep import (not the barrel) for the same reason as `constants/store-urls`:
// the @verso/shared barrel pulls zod + the full constant corpus and would bloat
// this landing bundle. `platform-classify` is a zero-dependency leaf.
import { classifyPlatform } from '@verso/shared/src/utils/platform-classify'

/** Which store listing this visitor should be sent to. `null` = desktop (show both). */
export type DownloadStore = 'ios' | 'android' | null

/**
 * Where the page is being viewed. Only the two paid-traffic in-app browsers are
 * distinguished - everything else (real browsers AND every other webview) is
 * `browser`, because nothing downstream branches on the difference.
 */
export type BrowserContext = 'instagram' | 'facebook' | 'browser'

export interface PlatformInfo {
  store: DownloadStore
  context: BrowserContext
}

function detectPlatform(): PlatformInfo {
  if (typeof navigator === 'undefined') return { store: null, context: 'browser' }
  const ua = navigator.userAgent || ''
  const { isAndroid, isIOS } = classifyPlatform(ua, navigator.maxTouchPoints)
  const store: DownloadStore = isAndroid ? 'android' : isIOS ? 'ios' : null
  const context: BrowserContext = /Instagram/i.test(ua)
    ? 'instagram'
    : /FBAN|FBAV/i.test(ua)
      ? 'facebook'
      : 'browser'
  return { store, context }
}

// The UA cannot change for the lifetime of the document, so classify once and
// hand every caller the SAME object - a stable identity keeps it safe to use as
// a hook dependency (e.g. the sticky bar's IntersectionObserver effect).
let cached: PlatformInfo | null = null

function readPlatform(): PlatformInfo {
  if (!cached) cached = detectPlatform()
  return cached
}

export function usePlatform(): PlatformInfo {
  return useMemo(readPlatform, [])
}
